import { type ReactNode } from "react";
import { AppShell, Burger, Group, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [opened, { toggle }] = useDisclosure();

  return (
    <AppShell
      navbar={{
        width: 250,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
      styles={{
        main: { backgroundColor: "#1a1a2e" },
        navbar: { backgroundColor: "#16213e", borderColor: "#0f3460" },
      }}
    >
      <AppShell.Navbar>
        <Sidebar onClose={toggle} />
      </AppShell.Navbar>

      <AppShell.Main>
        <Group hiddenFrom="sm" mb="md">
          <Burger opened={opened} onClick={toggle} size="sm" color="#eeeeee" />
          <Text c="primary" fw={700}>
            Qasa Notifier
          </Text>
        </Group>
        {children}
      </AppShell.Main>
    </AppShell>
  );
}
